import React, { useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import CreateNewBtn from "./CreateNewBtn";
import axios from "axios";
import { ReimbursementAPIs } from "./MyReimbursementAPI's";
import { UserConsumer } from "../../UserContext";
import CustomReactSelect from "../../components/CustomReactSelect";
import DatePicker from "react-datepicker";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ReimbursementBar = (props) => {
	const history = useHistory();
	let token = null;
	const startDatepickerRef = useRef(null);
	const endDatepickerRef = useRef(null);
	let date = new Date();
	const currMonth = date.getMonth() + 1;
	const getRecord = () => {
		axios
			.get(
				`${
					ReimbursementAPIs.GetSingleReimbursement
				}?Month=${currMonth}&Year=${date.getFullYear()}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then(({ data }) => {
				history.push({
					pathname: `/monthlyReimbursement/${data.appID}`,
					state: {
						detail: data,
						selectedMonth: props.selectedMonth,
						selectedYear: props.selectedYear,
						status: props.status,
						employeeId: props.employeeId,
					},
				});
			});
	};
	const openStartDatepicker = () => {
		const datepickerElement = startDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const openEndDatepicker = () => {
		const datepickerElement = endDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<>
						{props.monthlyReimburse ? (
							<CreateNewBtn
								btnClicked={() => getRecord()}
								monthlyReimburse={props.monthlyReimburse}
								years={props.years}
							/>
						) : (
							<CreateNewBtn
								btnClicked={() =>
									history.push("/generalReimbursement")
								}
							/>
						)}
						<Container fluid className="Bar">
							<Row>
								<Col className="d-flex justify-content-between align-items-center reimbursement-status">
									<label className="mb-0">By Status </label>
									<CustomReactSelect
										placeholder="All"
										className="status-field"
										options={props.getStatus}
										onChange={(obj) =>
											props.handleStatus(obj)
										}
										isSearchable={false}
										value={props.status}
									/>
								</Col>
								<Col className="d-flex align-items-center justify-content-between">
									<label className="mb-0">By Year</label>
									<CustomReactSelect
										placeholder="2022"
										className="year-field"
										options={props.years}
										onChange={(obj) =>
											props.byYearHandler(obj)
										}
										isSearchable={false}
										value={props.selectedYear}
									/>
								</Col>
								{props.empDepartment === "5" && (
									<Col className="d-flex align-items-center justify-content-between">
										<label className="mb-0 mr-2">
											Employee
										</label>
										<CustomReactSelect
											placeholder="All"
											className="year-field"
											options={props.allEmployeesList}
											onChange={(obj) =>
												props.getEmployeeID(obj)
											}
											isSearchable={false}
											value={props.employeeId}
										/>
									</Col>
								)}
								{props.empDepartment === "5" && (
									<Col className="d-flex align-items-center justify-content-between">
										<label className="mb-0">By Month</label>
										<CustomReactSelect
											className="year-field"
											options={props.monthsList}
											onChange={(obj) =>
												props.byMonthHanlder(obj)
											}
											isSearchable={false}
											value={props.selectedMonth}
										/>
									</Col>
								)}
							</Row>
							{props.empDepartment === "5" && (
								<Row className="mt-2">
									<Col className="d-flex align-items-center justify-content-between">
										<label className="mb-0">
											Start Date
										</label>
										<Col className="datepicker-wrapper">
											<DatePicker
												showYearDropdown
												showMonthDropdown
												dateFormatCalendar=" " //for title
												dateFormat="dd/MM/yyyy"
												name="lStartDate"
												className="custom-container"
												selected={props.startDate}
												onChange={(e) =>
													props.onStartDateChange(e)
												}
												autoComplete="off"
												maxDate={date}
												ref={startDatepickerRef}
											/>
											<FontAwesomeIcon
												icon={faCalendarAlt}
												className="calender-icon"
												color="keppel"
												onClick={() =>
													openStartDatepicker()
												}
											/>
										</Col>
									</Col>
									<Col className="d-flex align-items-center justify-content-between">
										<label className="mb-0">End Date</label>
										<Col className="datepicker-wrapper">
											<DatePicker
												showYearDropdown
												showMonthDropdown
												dateFormatCalendar=" " //for title
												dateFormat="dd/MM/yyyy"
												name="lEndDate"
												className="custom-container"
												selected={props.endDate}
												onChange={(e) =>
													props.onEndDateChange(e)
												}
												autoComplete="off"
												minDate={props.startDate}
												maxDate={date}
												ref={endDatepickerRef}
											/>
											<FontAwesomeIcon
												icon={faCalendarAlt}
												className="calender-icon"
												color="keppel"
												onClick={() =>
													openEndDatepicker()
												}
											/>
										</Col>
									</Col>
								</Row>
							)}
						</Container>
					</>
				);
			}}
		</UserConsumer>
	);
};

export default ReimbursementBar;
